export function isPlayerId(object) {
    return object?.charAt?.(0) === 'p';
}
export function isGameId(object) {
    return object?.charAt?.(0) === 'g';
}
export function isSpectatorId(object) {
    return object?.charAt?.(0) === 's';
}
export function isSpaceId(object) {
    return /^[cm]?[0-9][0-9]$/.test(object);
}
export function safeCast(object, tester) {
    if (tester(object)) {
        return object;
    }
    throw new Error('failed cast: ' + tester.name);
}
